import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IpWhitelistState } from '../../services/client-access.service';

@Component({
  selector: 'app-ip-whitelist-attention',
  templateUrl: './ip-whitelist-attention.component.html'
})
export class IpWhitelistAttentionComponent {
  @Input() state: IpWhitelistState | null = null;
  @Output() requestWhitelist = new EventEmitter<void>();
}